import React from 'react'

import {
    UpdateMemberDetailsFormComponent,
    UpdateMemberDetailsFormFieldComponent,
    UpdateMemberDetailsFormFieldName,
} from '@vista-digital/occ-ui'
import { updateMemberFormProps } from './props'

export const PersonalDetailsComponent: React.FC = () => {
    return (
        <UpdateMemberDetailsFormComponent {...updateMemberFormProps}>
            <div className="personal-details-member">
                <h6>Member Details</h6>
                <UpdateMemberDetailsFormFieldComponent
                    name={UpdateMemberDetailsFormFieldName.GivenName}
                    displayText={{
                        label: 'First Name',
                    }}
                />
                <UpdateMemberDetailsFormFieldComponent
                    name={UpdateMemberDetailsFormFieldName.FamilyName}
                    displayText={{
                        label: 'Last Name',
                    }}
                />
                <UpdateMemberDetailsFormFieldComponent name={UpdateMemberDetailsFormFieldName.Gender} />
                <UpdateMemberDetailsFormFieldComponent name={UpdateMemberDetailsFormFieldName.DateOfBirth} />
                <UpdateMemberDetailsFormFieldComponent name={UpdateMemberDetailsFormFieldName.MobileNumber} />
                <UpdateMemberDetailsFormFieldComponent name={UpdateMemberDetailsFormFieldName.PrimarySite} />
            </div>
            <div className="personal-details-address">
                <h6>Address Details</h6>
                <UpdateMemberDetailsFormFieldComponent name={UpdateMemberDetailsFormFieldName.Address} />
                <UpdateMemberDetailsFormFieldComponent name={UpdateMemberDetailsFormFieldName.City} />
                <UpdateMemberDetailsFormFieldComponent name={UpdateMemberDetailsFormFieldName.State} />
                <UpdateMemberDetailsFormFieldComponent
                    name={UpdateMemberDetailsFormFieldName.PostCode}
                    displayText={{
                        label: 'Zipcode',
                    }}
                />
            </div>
        </UpdateMemberDetailsFormComponent>
    )
}

export default PersonalDetailsComponent
